import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import {
  PROJECT,
  TrackingPage,
  PressContinueTrackingEvent,
  TrackingEventName,
  TrackingEventCategory,
} from "./tracking";

interface PressContinueFunction {
  (): void;
}

interface UseTrackPressContinueFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly checkoutId: string | undefined;
  readonly tradename: Tradename;
}
interface UseTrackPressContinueFunction {
  (agrs: UseTrackPressContinueFunctionArgs): PressContinueFunction;
}

const useTrackPressContinue: UseTrackPressContinueFunction = ({ page, country, tradename, segment, checkoutId }) => {
  const emitUserEvent = useEmitUserEvent<PressContinueTrackingEvent>();

  const pressContinue: PressContinueFunction = useCallback(() => {
    if (!checkoutId) {
      return;
    }

    const pressContinueTrackingEvent: PressContinueTrackingEvent = {
      event: TrackingEventName.PRESS_CONTINUE,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_${page}`,
      store: country,
      tradename,
      segment,
      checkoutId,
    };

    emitUserEvent(pressContinueTrackingEvent);
  }, [checkoutId, country, tradename, emitUserEvent, page, segment]);

  return pressContinue;
};

export { useTrackPressContinue };
